// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.BibliographyEditor table[data-v-850de562]
	{
		border-collapse: collapse;
		table-layout: fixed;
		width: 100%;
}
.BibliographyEditor tr[data-v-850de562]:nth-child(2n)
	{
		/*background-color: rgba(0,0,0,0.065);*/
}
.BibliographyEditor tr.newRow[data-v-850de562]
	{
		background-color: rgba(0,0,255,0.05);
}
.BibliographyEditor tr.newRow[data-v-850de562]:nth-child(2n)
		{
			/*background-color: rgba(0,255,0,0.19);*/
}
.BibliographyEditor tr.delete[data-v-850de562]
	{
		text-decoration: line-through;
		background-color: rgba(255,0,0,0.15);
}
.BibliographyEditor tr.delete[data-v-850de562]:nth-child(2n)
		{
			/*background-color: rgba(255,0,0,0.295);*/
}
.BibliographyEditor td[data-v-850de562]
	{
		border: 1px solid #333333;
		padding: 2px 3px;
		font-size: 14px;
}
.BibliographyEditor td[data-v-850de562]:nth-child(1)
		{
			width: 20px;
			vertical-align: top;
			padding: 0px;
}
.BibliographyEditor td[data-v-850de562]:nth-child(2)
		{
			width: 20px;
			vertical-align: top;
			padding: 0px;
}
.BibliographyEditor td[data-v-850de562]:nth-child(3)
		{
			padding: 0px;
			width: 120px;
			word-break: break-word;
			vertical-align: top;
}
.BibliographyEditor td[data-v-850de562]:nth-child(4)
		{
}
.BibliographyEditor td[data-v-850de562]:nth-child(5)
		{
			width: 16px;
			vertical-align: top;
}
.BibliographyEditor td.changed[data-v-850de562]
		{
			background-color: rgba(0,0,255,0.14);
			outline: 2px solid #0000FF;
}
.BibliographyEditor td.drag_handle[data-v-850de562]
		{
			width: 20px;
			height: 20px;
			padding: 0px;
			font-size: 0px;
			cursor: grab;
}
.BibliographyEditor td.drag_handle.moved[data-v-850de562]
			{
				background-color: rgba(0,0,255,0.14);
				outline: 2px solid #0000FF;
}
.BibliographyEditor td.drag_handle svg[data-v-850de562]
			{
				width: 20px;
				height: 20px;
}
.BibliographyEditor tr.newRow td[data-v-850de562]
	{
		border-color: #0000FF;
}
.btnIcon[data-v-850de562],
	.btnIconNoHover[data-v-850de562]
	{
		width: 16px;
		height: 16px;
		cursor: pointer;
		vertical-align: bottom;
}
.sortResetBtn[data-v-850de562]:hover,
		.sortResetBtn[data-v-850de562]:focus,
		.sortAZBtn[data-v-850de562]:hover,
		.sortAZBtn[data-v-850de562]:focus,
		.btnIcon[data-v-850de562]:hover,
		.btnIcon[data-v-850de562]:focus
		{
			background-color: rgba(0,0,0,0.2);
			outline: 2px solid rgba(0,0,255,0.5);
}
.undoButton[data-v-850de562]
	{
		margin: 0px;
		border: 0px;
		width: 20px;
		height: 20px;
		padding: 0px;
		font-size: 0px;
}
.undoButton svg[data-v-850de562]
		{
			width: 20px;
			height: 20px;
}
.bTypeSelect[data-v-850de562]
	{
		background-color: transparent;
		border: none;
		box-sizing: border-box;
		padding: 2px 3px;
		width: 100%;
		appearance: none;
		cursor: pointer;
		height: 20px;
}
.bTypeSelect[data-v-850de562]:hover,
		.bTypeSelect[data-v-850de562]:focus
		{
			background-color: rgba(0,0,0,0.2);
}
.bTypeSelect option[data-v-850de562]
		{
			background-color: #FFFFFF;
}
.BibliographyEditor tr.delete .bTypeSelect[data-v-850de562]
	{
		text-decoration: line-through;
}
.editableValue[data-v-850de562]
	{
		white-space: pre;
}
.shake[data-v-850de562]
	{
		-webkit-animation: kf_shake-850de562 0.4s 1 linear;
		-moz-animation: kf_shake-850de562 0.4s 1 linear;
		-o-animation: kf_shake-850de562 0.4s 1 linear;
		animation: kf_shake-850de562 0.4s linear 0 1;
}
.shake td[data-v-850de562]
		{
			border-color: #FF0000;
			background-color: rgba(255,0,0,0.15);
}
@-webkit-keyframes kf_shake-850de562
	{
0%
		{
			-webkit-transform: translate(30px);
}
20%
		{
			-webkit-transform: translate(-30px);
}
40%
		{
			-webkit-transform: translate(15px);
}
60%
		{
			-webkit-transform: translate(-15px);
}
80%
		{
			-webkit-transform: translate(8px);
}
100%
		{
			-webkit-transform: translate(0px);
}
}
@-moz-keyframes kf_shake-850de562
	{
0%
		{
			-moz-transform: translate(30px);
}
20%
		{
			-moz-transform: translate(-30px);
}
40%
		{
			-moz-transform: translate(15px);
}
60%
		{
			-moz-transform: translate(-15px);
}
80%
		{
			-moz-transform: translate(8px);
}
100%
		{
			-moz-transform: translate(0px);
}
}
@-o-keyframes kf_shake-850de562
	{
0%
		{
			-o-transform: translate(30px);
}
20%
		{
			-o-transform: translate(-30px);
}
40%
		{
			-o-transform: translate(15px);
}
60%
		{
			-o-transform: translate(-15px);
}
80%
		{
			-o-transform: translate(8px);
}
100%
		{
			-o-origin-transform: translate(0px);
}
}
@keyframes kf_shake-850de562
	{
0%
		{
			transform: translate(30px);
}
20%
		{
			transform: translate(-30px);
}
40%
		{
			transform: translate(15px);
}
60%
		{
			transform: translate(-15px);
}
80%
		{
			transform: translate(8px);
}
100%
		{
			transform: translate(0px);
}
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/controls/BibliographyEditor.vue"],"names":[],"mappings":";AAkLC;;EAEC,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACZ;AAEA;;EAEC,uCAAuC;AACxC;AAEA;;EAEC,oCAAoC;AACrC;AAEC;;GAEC,wCAAwC;AACzC;AAED;;EAEC,6BAA6B;EAC7B,oCAAoC;AACrC;AAEC;;GAEC,yCAAyC;AAC1C;AAGD;;EAEC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AAChB;AAEC;;GAEC,WAAW;GACX,mBAAmB;GACnB,YAAY;AACb;AAEA;;GAEC,WAAW;GACX,mBAAmB;GACnB,YAAY;AACb;AAEA;;GAEC,YAAY;GACZ,YAAY;GACZ,sBAAsB;GACtB,mBAAmB;AACpB;AAEA;;AAEA;AAEA;;GAEC,WAAW;GACX,mBAAmB;AACpB;AAEA;;GAEC,oCAAoC;GACpC,0BAA0B;AAC3B;AAEA;;GAEC,WAAW;GACX,YAAY;GACZ,YAAY;GACZ,cAAc;GACd,YAAY;AACb;AAEC;;IAEC,oCAAoC;IACpC,0BAA0B;AAC3B;AAEA;;IAEC,WAAW;IACX,YAAY;AACb;AAEF;;EAEC,qBAAqB;AACtB;AAEA;;;EAGC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;AACvB;AAEC;;;;;;;GAOC,iCAAiC;GACjC,oCAAoC;AACrC;AAGD;;EAEC,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;AACf;AAEC;;GAEC,WAAW;GACX,YAAY;AACb;AAED;;EAEC,6BAA6B;EAC7B,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,YAAY;AACb;AAEC;;;GAGC,iCAAiC;AAClC;AAEA;;GAEC,yBAAyB;AAC1B;AAED;;EAEC,6BAA6B;AAC9B;AAEA;;EAEC,gBAAgB;AACjB;AAEA;;EAEC,kDAAyC;EACzC,+CAAsC;EACtC,6CAAoC;EACpC,4CAAmC;AACpC;AAEC;;GAEC,qBAAqB;GACrB,oCAAoC;AACrC;AAED;;AAEC;;GAEC,kCAAkC;AACnC;AAEA;;GAEC,mCAAmC;AACpC;AAEA;;GAEC,kCAAkC;AACnC;AAEA;;GAEC,mCAAmC;AACpC;AAEA;;GAEC,iCAAiC;AAClC;AAEA;;GAEC,iCAAiC;AAClC;AACD;AAEA;;AAEC;;GAEC,+BAA+B;AAChC;AAEA;;GAEC,gCAAgC;AACjC;AAEA;;GAEC,+BAA+B;AAChC;AAEA;;GAEC,gCAAgC;AACjC;AAEA;;GAEC,8BAA8B;AAC/B;AAEA;;GAEC,8BAA8B;AAC/B;AACD;AAEA;;AAEC;;GAEC,6BAA6B;AAC9B;AAEA;;GAEC,8BAA8B;AAC/B;AAEA;;GAEC,6BAA6B;AAC9B;AAEA;;GAEC,8BAA8B;AAC/B;AAEA;;GAEC,4BAA4B;AAC7B;AAEA;;GAEC,mCAAmC;AACpC;AACD;AAEA;;AAEC;;GAEC,0BAA0B;AAC3B;AAEA;;GAEC,2BAA2B;AAC5B;AAEA;;GAEC,0BAA0B;AAC3B;AAEA;;GAEC,2BAA2B;AAC5B;AAEA;;GAEC,yBAAyB;AAC1B;AAEA;;GAEC,yBAAyB;AAC1B;AACD","sourcesContent":["<template>\r\n\t<div class=\"BibliographyEditor\">\r\n\t\t<table>\r\n\t\t\t<draggable v-model=\"rev.Bibliography\" tag=\"tbody\" handle=\".drag_handle\" @change=\"dragged\" item-key=\"originalIndex\">\r\n\t\t\t\t<template #item=\"{ element: b, index }\">\r\n\t\t\t\t\t<tr :class=\"{ delete: b.delete, newRow: b.newRow, shake: b.shake }\">\r\n\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t<button v-if=\"b.Type !== b.originalType || b.Value !== b.originalValue || b.delete\" class=\"undoButton btnIcon\" role=\"button\" tabindex=\"0\" @click=\"onUndo(b)\"\r\n\t\t\t\t\t\t\t\t\ttitle=\"undo changes to this row\">\r\n\t\t\t\t\t\t\t\t<vsvg sprite=\"replay\" />\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td :class=\"{ drag_handle: true, moved: b.index !== b.originalIndex }\"><vsvg sprite=\"drag_indicator\" /></td>\r\n\t\t\t\t\t\t<td :class=\"{ changed: b.Type !== b.originalType }\">\r\n\t\t\t\t\t\t\t<select v-model=\"b.Type\" class=\"bTypeSelect\">\r\n\t\t\t\t\t\t\t\t<option v-for=\"bType in allBibliographyTypes\" :key=\"bType\">{{bType}}</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<!-- A function ref is required here: string refs inside a scoped slot do not accumulate into an array the way v-for refs do. -->\r\n\t\t\t\t\t\t<Contenteditable tag=\"td\" v-model=\"b.Value\" :no-html=\"true\" :class=\"{ changed: b.Value !== b.originalValue }\" :no-nl=\"true\" @returned=\"onEnterPressed(index)\" :ref=\"el => SetValueRef(el, index)\" />\r\n\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t<img class=\"btnIcon\" :src=\"appPath + 'Images/delete.png'\" alt=\"delete\" role=\"button\" tabindex=\"0\" @click=\"onDelete(b)\" @keypress.space.enter.prevent=\"onDelete(b)\"\r\n\t\t\t\t\t\t\t\t title=\"mark/unmark this row for deletion\" />\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</template>\r\n\t\t\t</draggable>\r\n\t\t</table>\r\n\t\t<div class=\"buttonBar\">\r\n\t\t\t<button class=\"buttonBarButton\" @click=\"onAdd()\" title=\"add a row to the bibliography table\">\r\n\t\t\t\t<img class=\"btnIconNoHover\" :src=\"appPath + 'Images/add.png'\" alt=\"\" role=\"presentation\" />\r\n\t\t\t\t<span>Add Row</span>\r\n\t\t\t</button>\r\n\t\t\t<button class=\"buttonBarButton\" v-if=\"rowOrderChanged\" @click=\"sortReset()\" title=\"reset row order\">\r\n\t\t\t\t<img class=\"btnIconNoHover\" :src=\"appPath + 'Images/nav_undo_blue.png'\" alt=\"\" role=\"presentation\" />\r\n\t\t\t\t<span>Reset Row Order</span>\r\n\t\t\t</button>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\timport Contenteditable from 'appRoot/vues/common/controls/Contenteditable.vue';\r\n\timport draggable from 'vuedraggable'\r\n\timport { PreprocessBibliographyRecord, DefineReactiveNonEnumerableProperty } from 'appRoot/scripts/Util';\r\n\timport svg1 from 'appRoot/images/sprite/replay.svg';\r\n\timport svg2 from 'appRoot/images/sprite/drag_indicator.svg';\r\n\r\n\texport default {\r\n\t\tcomponents: { Contenteditable, draggable },\r\n\t\tprops:\r\n\t\t{\r\n\t\t\trev: { // Modifiable revision\r\n\t\t\t\ttype: Object,\r\n\t\t\t\trequired: true\r\n\t\t\t}\r\n\t\t},\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t\tappPath: appContext.appPath\r\n\t\t\t};\r\n\t\t},\r\n\t\tcreated()\r\n\t\t{\r\n\t\t\tthis.valueRefs = []; // Intentionally not in data(): holds Contenteditable component instances (per row index) which should not be made reactive.\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t\tallBibliographyTypes()\r\n\t\t\t{\r\n\t\t\t\treturn this.$store.state.bibliographyTypes;\r\n\t\t\t},\r\n\t\t\trowOrderChanged()\r\n\t\t\t{\r\n\t\t\t\tfor (let i = 0; i < this.rev.Bibliography.length; i++)\r\n\t\t\t\t{\r\n\t\t\t\t\tlet b = this.rev.Bibliography[i];\r\n\t\t\t\t\tif (b.index !== b.originalIndex)\r\n\t\t\t\t\t\treturn true;\r\n\t\t\t\t}\r\n\t\t\t\treturn false;\r\n\t\t\t}\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t\tonDelete(b)\r\n\t\t\t{\r\n\t\t\t\tb.delete = !b.delete;\r\n\t\t\t},\r\n\t\t\tonUndo(b)\r\n\t\t\t{\r\n\t\t\t\tb.Type = b.originalType;\r\n\t\t\t\tb.Value = b.originalValue;\r\n\t\t\t\tb.delete = false;\r\n\t\t\t},\r\n\t\t\tSetValueRef(component, index)\r\n\t\t\t{\r\n\t\t\t\tthis.valueRefs[index] = component;\r\n\t\t\t},\r\n\t\t\tonEnterPressed(i)\r\n\t\t\t{\r\n\t\t\t\tif (this.valueRefs && i + 1 < this.valueRefs.length)\r\n\t\t\t\t{\r\n\t\t\t\t\tlet component = this.valueRefs[i + 1];\r\n\t\t\t\t\tif (component && component.$el)\r\n\t\t\t\t\t\tcomponent.$el.focus();\r\n\t\t\t\t}\r\n\t\t\t},\r\n\t\t\tonAdd()\r\n\t\t\t{\r\n\t\t\t\tlet record = PreprocessBibliographyRecord({ Type: \"\", Value: \"\" }, this.rev.Bibliography.length);\r\n\t\t\t\tDefineReactiveNonEnumerableProperty(record, \"newRow\", true);\r\n\t\t\t\tthis.rev.Bibliography.push(record);\r\n\t\t\t},\r\n\t\t\tdragged()\r\n\t\t\t{\r\n\t\t\t\tfor (let i = 0; i < this.rev.Bibliography.length; i++)\r\n\t\t\t\t{\r\n\t\t\t\t\tconsole.log(this.rev.Bibliography[i].index + \" -> \" + i);\r\n\t\t\t\t\tthis.rev.Bibliography[i].index = i;\r\n\t\t\t\t}\r\n\t\t\t},\r\n\t\t\tsortReset() // Obsolete\r\n\t\t\t{\r\n\t\t\t\tthis.rev.Bibliography.sort(compareFn([o => o.originalIndex], false));\r\n\t\t\t\tthis.dragged();\r\n\t\t\t},\r\n\t\t\tsortByType() // Obsolete\r\n\t\t\t{\r\n\t\t\t\tlet beforeSort = JSON.stringify(this.rev.Bibliography);\r\n\t\t\t\tthis.rev.Bibliography.sort(compareType(false));\r\n\t\t\t\tlet afterSort = JSON.stringify(this.rev.Bibliography);\r\n\t\t\t\tif (beforeSort === afterSort)\r\n\t\t\t\t\tthis.rev.Bibliography.sort(compareType(true));\r\n\t\t\t\tthis.dragged();\r\n\t\t\t},\r\n\t\t\tsortByValue() // Obsolete\r\n\t\t\t{\r\n\t\t\t\tlet beforeSort = JSON.stringify(this.rev.Bibliography);\r\n\t\t\t\tthis.rev.Bibliography.sort(compareValue(false));\r\n\t\t\t\tlet afterSort = JSON.stringify(this.rev.Bibliography);\r\n\t\t\t\tif (beforeSort === afterSort)\r\n\t\t\t\t\tthis.rev.Bibliography.sort(compareValue(true));\r\n\t\t\t\tthis.dragged();\r\n\t\t\t}\r\n\t\t},\r\n\t\twatch:\r\n\t\t{\r\n\t\t}\r\n\t}\r\n\tfunction compareType(descending)\r\n\t{\r\n\t\treturn compareFn([o => o.Type.toUpperCase(), o => o.Value.toUpperCase()], descending);\r\n\t}\r\n\tfunction compareValue(descending)\r\n\t{\r\n\t\treturn compareFn([o => o.Value.toUpperCase(), o => o.Type.toUpperCase()], descending);\r\n\t}\r\n\tfunction compareFn(keySelectors, descending)\r\n\t{\r\n\t\treturn (a, b) =>\r\n\t\t{\r\n\t\t\tfor (let i = 0; i < keySelectors.length; i++)\r\n\t\t\t{\r\n\t\t\t\tconst keyA = keySelectors[i](a);\r\n\t\t\t\tconst keyB = keySelectors[i](b);\r\n\t\t\t\tif (keyA < keyB)\r\n\t\t\t\t\treturn descending ? 1 : -1;\r\n\t\t\t\telse if (keyB < keyA)\r\n\t\t\t\t\treturn descending ? -1 : 1;\r\n\t\t\t}\r\n\t\t\treturn 0;\r\n\t\t};\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.BibliographyEditor table\r\n\t{\r\n\t\tborder-collapse: collapse;\r\n\t\ttable-layout: fixed;\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.BibliographyEditor tr:nth-child(2n)\r\n\t{\r\n\t\t/*background-color: rgba(0,0,0,0.065);*/\r\n\t}\r\n\r\n\t.BibliographyEditor tr.newRow\r\n\t{\r\n\t\tbackground-color: rgba(0,0,255,0.05);\r\n\t}\r\n\r\n\t\t.BibliographyEditor tr.newRow:nth-child(2n)\r\n\t\t{\r\n\t\t\t/*background-color: rgba(0,255,0,0.19);*/\r\n\t\t}\r\n\r\n\t.BibliographyEditor tr.delete\r\n\t{\r\n\t\ttext-decoration: line-through;\r\n\t\tbackground-color: rgba(255,0,0,0.15);\r\n\t}\r\n\r\n\t\t.BibliographyEditor tr.delete:nth-child(2n)\r\n\t\t{\r\n\t\t\t/*background-color: rgba(255,0,0,0.295);*/\r\n\t\t}\r\n\r\n\r\n\t.BibliographyEditor td\r\n\t{\r\n\t\tborder: 1px solid #333333;\r\n\t\tpadding: 2px 3px;\r\n\t\tfont-size: 14px;\r\n\t}\r\n\r\n\t\t.BibliographyEditor td:nth-child(1)\r\n\t\t{\r\n\t\t\twidth: 20px;\r\n\t\t\tvertical-align: top;\r\n\t\t\tpadding: 0px;\r\n\t\t}\r\n\r\n\t\t.BibliographyEditor td:nth-child(2)\r\n\t\t{\r\n\t\t\twidth: 20px;\r\n\t\t\tvertical-align: top;\r\n\t\t\tpadding: 0px;\r\n\t\t}\r\n\r\n\t\t.BibliographyEditor td:nth-child(3)\r\n\t\t{\r\n\t\t\tpadding: 0px;\r\n\t\t\twidth: 120px;\r\n\t\t\tword-break: break-word;\r\n\t\t\tvertical-align: top;\r\n\t\t}\r\n\r\n\t\t.BibliographyEditor td:nth-child(4)\r\n\t\t{\r\n\t\t}\r\n\r\n\t\t.BibliographyEditor td:nth-child(5)\r\n\t\t{\r\n\t\t\twidth: 16px;\r\n\t\t\tvertical-align: top;\r\n\t\t}\r\n\r\n\t\t.BibliographyEditor td.changed\r\n\t\t{\r\n\t\t\tbackground-color: rgba(0,0,255,0.14);\r\n\t\t\toutline: 2px solid #0000FF;\r\n\t\t}\r\n\r\n\t\t.BibliographyEditor td.drag_handle\r\n\t\t{\r\n\t\t\twidth: 20px;\r\n\t\t\theight: 20px;\r\n\t\t\tpadding: 0px;\r\n\t\t\tfont-size: 0px;\r\n\t\t\tcursor: grab;\r\n\t\t}\r\n\r\n\t\t\t.BibliographyEditor td.drag_handle.moved\r\n\t\t\t{\r\n\t\t\t\tbackground-color: rgba(0,0,255,0.14);\r\n\t\t\t\toutline: 2px solid #0000FF;\r\n\t\t\t}\r\n\r\n\t\t\t.BibliographyEditor td.drag_handle svg\r\n\t\t\t{\r\n\t\t\t\twidth: 20px;\r\n\t\t\t\theight: 20px;\r\n\t\t\t}\r\n\r\n\t.BibliographyEditor tr.newRow td\r\n\t{\r\n\t\tborder-color: #0000FF;\r\n\t}\r\n\r\n\t.btnIcon,\r\n\t.btnIconNoHover\r\n\t{\r\n\t\twidth: 16px;\r\n\t\theight: 16px;\r\n\t\tcursor: pointer;\r\n\t\tvertical-align: bottom;\r\n\t}\r\n\r\n\t\t.sortResetBtn:hover,\r\n\t\t.sortResetBtn:focus,\r\n\t\t.sortAZBtn:hover,\r\n\t\t.sortAZBtn:focus,\r\n\t\t.btnIcon:hover,\r\n\t\t.btnIcon:focus\r\n\t\t{\r\n\t\t\tbackground-color: rgba(0,0,0,0.2);\r\n\t\t\toutline: 2px solid rgba(0,0,255,0.5);\r\n\t\t}\r\n\r\n\r\n\t.undoButton\r\n\t{\r\n\t\tmargin: 0px;\r\n\t\tborder: 0px;\r\n\t\twidth: 20px;\r\n\t\theight: 20px;\r\n\t\tpadding: 0px;\r\n\t\tfont-size: 0px;\r\n\t}\r\n\r\n\t\t.undoButton svg\r\n\t\t{\r\n\t\t\twidth: 20px;\r\n\t\t\theight: 20px;\r\n\t\t}\r\n\r\n\t.bTypeSelect\r\n\t{\r\n\t\tbackground-color: transparent;\r\n\t\tborder: none;\r\n\t\tbox-sizing: border-box;\r\n\t\tpadding: 2px 3px;\r\n\t\twidth: 100%;\r\n\t\tappearance: none;\r\n\t\tcursor: pointer;\r\n\t\theight: 20px;\r\n\t}\r\n\r\n\t\t.bTypeSelect:hover,\r\n\t\t.bTypeSelect:focus\r\n\t\t{\r\n\t\t\tbackground-color: rgba(0,0,0,0.2);\r\n\t\t}\r\n\r\n\t\t.bTypeSelect option\r\n\t\t{\r\n\t\t\tbackground-color: #FFFFFF;\r\n\t\t}\r\n\r\n\t.BibliographyEditor tr.delete .bTypeSelect\r\n\t{\r\n\t\ttext-decoration: line-through;\r\n\t}\r\n\r\n\t.editableValue\r\n\t{\r\n\t\twhite-space: pre;\r\n\t}\r\n\r\n\t.shake\r\n\t{\r\n\t\t-webkit-animation: kf_shake 0.4s 1 linear;\r\n\t\t-moz-animation: kf_shake 0.4s 1 linear;\r\n\t\t-o-animation: kf_shake 0.4s 1 linear;\r\n\t\tanimation: kf_shake 0.4s linear 0 1;\r\n\t}\r\n\r\n\t\t.shake td\r\n\t\t{\r\n\t\t\tborder-color: #FF0000;\r\n\t\t\tbackground-color: rgba(255,0,0,0.15);\r\n\t\t}\r\n\r\n\t@-webkit-keyframes kf_shake\r\n\t{\r\n\t\t0%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(30px);\r\n\t\t}\r\n\r\n\t\t20%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(-30px);\r\n\t\t}\r\n\r\n\t\t40%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(15px);\r\n\t\t}\r\n\r\n\t\t60%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(-15px);\r\n\t\t}\r\n\r\n\t\t80%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(8px);\r\n\t\t}\r\n\r\n\t\t100%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(0px);\r\n\t\t}\r\n\t}\r\n\r\n\t@-moz-keyframes kf_shake\r\n\t{\r\n\t\t0%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(30px);\r\n\t\t}\r\n\r\n\t\t20%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(-30px);\r\n\t\t}\r\n\r\n\t\t40%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(15px);\r\n\t\t}\r\n\r\n\t\t60%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(-15px);\r\n\t\t}\r\n\r\n\t\t80%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(8px);\r\n\t\t}\r\n\r\n\t\t100%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(0px);\r\n\t\t}\r\n\t}\r\n\r\n\t@-o-keyframes kf_shake\r\n\t{\r\n\t\t0%\r\n\t\t{\r\n\t\t\t-o-transform: translate(30px);\r\n\t\t}\r\n\r\n\t\t20%\r\n\t\t{\r\n\t\t\t-o-transform: translate(-30px);\r\n\t\t}\r\n\r\n\t\t40%\r\n\t\t{\r\n\t\t\t-o-transform: translate(15px);\r\n\t\t}\r\n\r\n\t\t60%\r\n\t\t{\r\n\t\t\t-o-transform: translate(-15px);\r\n\t\t}\r\n\r\n\t\t80%\r\n\t\t{\r\n\t\t\t-o-transform: translate(8px);\r\n\t\t}\r\n\r\n\t\t100%\r\n\t\t{\r\n\t\t\t-o-origin-transform: translate(0px);\r\n\t\t}\r\n\t}\r\n\r\n\t@keyframes kf_shake\r\n\t{\r\n\t\t0%\r\n\t\t{\r\n\t\t\ttransform: translate(30px);\r\n\t\t}\r\n\r\n\t\t20%\r\n\t\t{\r\n\t\t\ttransform: translate(-30px);\r\n\t\t}\r\n\r\n\t\t40%\r\n\t\t{\r\n\t\t\ttransform: translate(15px);\r\n\t\t}\r\n\r\n\t\t60%\r\n\t\t{\r\n\t\t\ttransform: translate(-15px);\r\n\t\t}\r\n\r\n\t\t80%\r\n\t\t{\r\n\t\t\ttransform: translate(8px);\r\n\t\t}\r\n\r\n\t\t100%\r\n\t\t{\r\n\t\t\ttransform: translate(0px);\r\n\t\t}\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
